import axios from "axios";
import React, { Component, useState, useEffect, useContext } from "react";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { Cookies } from "../../../index.js";
import AdSense from "react-adsense";
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../../AppContext";
import { ClipLoader } from "react-spinners";
import { MyContext } from '../urlshorten_system/index'; // hoặc './Indexok'
import BitmediaAd from '../../mission/bitmedia';
function Check_done() {
    const { step_service, setstep_service, link_done, setlink_done , show_link_done, setshow_link_done  } = useContext(MyContext);
    const [nutxuly, setnutxuly] = useState("");
    const [disabledbutton, setdisabledbutton] = useState(false);
    const [buttonTextjop, setbuttonTextjop] = useState("Bước cuối ✔️ Click to Confirm");
    function laydulieu() {
        setnutxuly(1);
        const myCookieValue = Cookies.get("apikey");
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");

        axios
            .get("https://hust.media/link/load_logic/check_done.php", {
                params: {
                    lienket: hustmediavipro,
                    apikey: myCookieValue,
                    code_item: code_item
                },
            })
            .then((response) => {
                testFunction(response);
                setdisabledbutton(false);
                setnutxuly(0);
            })
            .catch((error) => {
                alert_error(error);
                setdisabledbutton(false);
                setnutxuly(0);
            });
    }
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        const order = info.order;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 1) {
            alert_success(message);
            setshow_link_done(true);
            setlink_done(order);
        }
        else if (response.data.status == 7) {
            // setlienketok(response.data.url);
        }

        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    function handleSubmit() {
        setdisabledbutton(true);
        laydulieu();
    };
    return (
        <>
            <div className="mx-auto max-w-md">
                <button disabled={disabledbutton}
                     onClick={handleSubmit}
                    className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                    <div className='flex items-center justify-between flex-1'>
                        {nutxuly == 1 &&
                            <div className="spinner-border" role="status">

                            </div>}


                        <span className='text-lg font-medium text-white'>
                            {buttonTextjop} </span>
                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                    </div>
                </button>
            </div>
            <BitmediaAd />
        </>
    );
}

export default Check_done;

